<template>
    <DForm
        @submit.prevent="submitForm"
    >
        <div class="dns-providers-form-wrapper">
            <DCard
                :title="__('settings.dns_providers.form_segments.general')"
                class="mb-4"
                padding
            >
                <DFormRow
                    :label="__('settings.dns_providers.form.name')"
                    is-required
                    :error="errorsData.name"
                    :hint="__('settings.dns_providers.form.name_hint')"
                >
                    <DInput
                        id="name"
                        v-model="form.name"
                        :placeholder="__('settings.dns_providers.form.name')"
                        :is-valid="isFormFieldValid('name')"
                        :disabled="onlyShowForm"
                        maxlength="128"
                    />
                </DFormRow>
            </DCard>
            <!-- API Settings -->
            <DCard
                :title="__('settings.dns_providers.form_segments.api')"
                class="mb-4"
                padding
            >
                <DFormRow
                    :label="__('settings.dns_providers.form.api_type_select')"
                    is-required
                    :hint="__('settings.dns_providers.form.api_type_select_hint')"
                    :error="errorsData.type"
                >
                    <DSelect
                        id="dns-provider-select"
                        v-model="form.type"
                        :options="apiTypes"
                        :placeholder="__('settings.dns_providers.form.api_type_select')"
                        :is-valid="isFormFieldValid('dns-provider-select')"
                        :disabled="onlyShowForm"
                        @update:value="updateSelectedApiType"
                    />
                </DFormRow>

                <DFormRow
                    v-if="isSelectedType('onehop_dns')"
                    :label="__('settings.dns_providers.form.api_url')"
                    is-required
                    :error="errorsData.api_url"
                    :hint="__('settings.dns_providers.form.api_url_hint')"
                >
                    <DInput
                        id="api_url"
                        v-model="form.api_url"
                        :placeholder="__('settings.dns_providers.form.api_url')"
                        :is-valid="isFormFieldValid('api_url')"
                        :disabled="onlyShowForm"
                        maxlength="128"
                    />
                </DFormRow>
                <DFormRow
                    v-if="isSelectedType('onehop_dns')"
                    :label="__('settings.dns_providers.form.username')"
                    is-required
                    :error="errorsData.api_username"
                    :hint="__('settings.dns_providers.form.username_hint')"
                >
                    <DInput
                        id="api_username"
                        v-model="form.api_username"
                        :placeholder="__('settings.dns_providers.form.username')"
                        :is-valid="isFormFieldValid('api_username')"
                        :disabled="onlyShowForm"
                        maxlength="128"
                    />
                </DFormRow>
                <DFormRow
                    v-if="isSelectedType('onehop_dns')"
                    :label="__('settings.dns_providers.form.password')"
                    is-required
                    :error="errorsData.api_password"
                    :hint="__('settings.dns_providers.form.password_hint')"
                >
                    <DSecretInput
                        id="api_password"
                        v-model="form.api_password"
                        v-model:cleared="form.clear_api_password"
                        :is-stored="storedSecrets.api_password"
                        :placeholder="__('settings.dns_providers.form.password')"
                        :is-valid="isFormFieldValid('api_password')"
                        :disabled="onlyShowForm"
                        maxlength="255"
                    />
                </DFormRow>
                <DFormRow
                    v-if="isSelectedType('onehop_dns')"
                    :label="__('settings.dns_providers.form.brand')"
                    is-required
                    :error="errorsData.api_brand"
                    :hint="__('settings.dns_providers.form.brand_hint')"
                >
                    <DInput
                        id="api_brand"
                        v-model="form.api_brand"
                        :placeholder="__('settings.dns_providers.form.brand')"
                        :is-valid="isFormFieldValid('api_brand')"
                        :disabled="onlyShowForm"
                        maxlength="128"
                    />
                </DFormRow>
                <DFormRow
                    v-if="isSelectedType('onehop_dns')"
                    :label="__('settings.dns_providers.form.region')"
                    is-required
                    :error="errorsData.region"
                    :hint="__('settings.dns_providers.form.region_hint')"
                >
                    <DInput
                        id="region"
                        v-model="form.region"
                        :placeholder="__('settings.dns_providers.form.region')"
                        :is-valid="isFormFieldValid('region')"
                        :disabled="onlyShowForm"
                        maxlength="128"
                    />
                </DFormRow>
                <DRow
                    v-if="isSelectedType('onehop_dns')"
                >
                    <DCol sm="4" />
                    <DCol sm="4">
                        <div
                            v-show="connectionStatus === 'successful'"
                            class="green-text"
                        >
                            {{ __('settings.connections.connection_successful') }}
                        </div>
                        <div
                            v-show="connectionStatus === 'unsuccessful'"
                            class="red-text"
                        >
                            {{ __('settings.connections.connection_unsuccessful') }}
                        </div>
                    </DCol>
                    <DCol
                        sm="4"
                        class="check-database-connection-btn"
                    >
                        <DButton
                            icon="lan-connect"
                            :label="__('settings.connections.check_connection')"
                            :disabled="onlyShowForm"
                            @click="checkConnection"
                        />
                    </DCol>
                </DRow>
                <DFormRow
                    v-if="isSelectedType('cloudpit_classic_dns')"
                    :label="__('settings.cloudpit_settings.form.login_url')"
                    :is-required="true"
                    :error="errors.login_url"
                    :hint="__('settings.cloudpit_settings.form.login_url_hint')"
                >
                    <DInput
                        id="login_url"
                        v-model="form.login_url"
                        :placeholder="__('settings.cloudpit_settings.form.login_url')"
                        :is-valid="isFormFieldValid('login_url')"
                        :disabled="onlyShowForm"
                        maxlength="128"
                    />
                </DFormRow>
                <DFormRow
                    v-if="isSelectedType('cloudpit_classic_dns')"
                    :label="__('settings.cloudpit_settings.form.api_url')"
                    :is-required="true"
                    :error="errorsData.api_url"
                    :hint="__('settings.cloudpit_settings.form.api_url_hint')"
                >
                    <DInput
                        id="api_url"
                        v-model="form.api_url"
                        :placeholder="__('settings.cloudpit_settings.form.api_url')"
                        :is-valid="isFormFieldValid('api_url')"
                        :disabled="onlyShowForm"
                        maxlength="128"
                    />
                </DFormRow>
                <DFormRow
                    v-if="isSelectedType('cloudpit_classic_dns')"
                    :label="__('settings.cloudpit_settings.form.client_id')"
                    :is-required="true"
                    :error="errorsData.client_id"
                    :hint="__('settings.cloudpit_settings.form.client_id_hint')"
                >
                    <DInput
                        id="client_id"
                        v-model="form.client_id"
                        :placeholder="__('settings.cloudpit_settings.form.client_id')"
                        :is-valid="isFormFieldValid('client_id')"
                        :disabled="onlyShowForm"
                        type="number"
                        min="0"
                        max="4294967295"
                    />
                </DFormRow>
                <DFormRow
                    v-if="isSelectedType('cloudpit_classic_dns')"
                    :label="__('settings.cloudpit_settings.form.client_secret')"
                    :is-required="!storedSecrets.client_secret"
                    :error="errorsData.client_secret"
                    :hint="__('settings.cloudpit_settings.form.client_secret_hint')"
                >
                    <DSecretInput
                        id="client_secret"
                        v-model="form.client_secret"
                        v-model:cleared="form.clear_client_secret"
                        :is-stored="storedSecrets.client_secret"
                        :placeholder="__('settings.cloudpit_settings.form.client_secret')"
                        :is-valid="isFormFieldValid('client_secret')"
                        :disabled="onlyShowForm"
                        maxlength="255"
                    />
                </DFormRow>
                <DFormRow
                    v-if="isSelectedType('cloudpit_classic_dns')"
                    :label="__('settings.cloudpit_settings.form.login_digits')"
                    :is-required="true"
                    :error="errorsData.login_digits"
                    :hint="__('settings.cloudpit_settings.form.login_digits_hint')"
                >
                    <DInput
                        id="login_digits"
                        v-model="form.login_digits"
                        :placeholder="__('settings.cloudpit_settings.form.login_digits')"
                        :is-valid="isFormFieldValid('login_digits')"
                        :disabled="onlyShowForm"
                        type="number"
                        min="0"
                        max="255"
                    />
                </DFormRow>
                <DFormRow
                    v-if="isSelectedType('cloudpit_classic_dns')"
                    :label="__('settings.cloudpit_settings.form.login_prefix')"
                    :is-required="true"
                    :error="errorsData.login_prefix"
                    :hint="__('settings.cloudpit_settings.form.login_prefix_hint')"
                >
                    <DInput
                        id="login_prefix"
                        v-model="form.login_prefix"
                        :placeholder="__('settings.cloudpit_settings.form.login_prefix')"
                        :is-valid="isFormFieldValid('login_prefix')"
                        :disabled="onlyShowForm"
                        maxlength="6"
                    />
                </DFormRow>
                <DFormRow
                    v-if="isSelectedType('cloudpit_classic_dns')"
                    :label="__('settings.cloudpit_settings.form.slug')"
                    :is-required="true"
                    :error="errorsData.slug"
                    :hint="__('settings.cloudpit_settings.form.slug_hint')"
                >
                    <DInput
                        id="slug"
                        v-model="form.slug"
                        :placeholder="__('settings.cloudpit_settings.form.slug')"
                        :is-valid="isFormFieldValid('slug')"
                        :disabled="onlyShowForm"
                        maxlength="20"
                    />
                </DFormRow>
                <DFormRow
                    v-if="isSelectedType('cloudpit_classic_dns')"
                    :label="__('settings.cloudpit_settings.form.dns_client_login')"
                    :is-required="true"
                    :error="errorsData.dns_client_login"
                    :hint="__('settings.cloudpit_settings.form.dns_client_login_hint')"
                >
                    <DInput
                        id="dns_client_login"
                        v-model="form.dns_client_login"
                        :placeholder="__('settings.cloudpit_settings.form.dns_client_login')"
                        :is-valid="isFormFieldValid('dns_client_login')"
                        :disabled="onlyShowForm"
                        maxlength="20"
                    />
                </DFormRow>
                <DRow
                    v-if="isSelectedType('cloudpit_classic_dns')"
                >
                    <DCol sm="4" />
                    <DCol sm="4">
                        <div
                            v-show="apiConnectionStatus === 'successful'"
                            class="green-text"
                        >
                            {{ __('settings.cloudpit_settings.connection_successful') }}
                        </div>
                        <div
                            v-show="apiConnectionStatus === 'unsuccessful'"
                            class="red-text"
                        >
                            {{ __('settings.cloudpit_settings.connection_unsuccessful') }}
                        </div>
                    </DCol>
                    <DCol
                        sm="4"
                        class="check-database-connection-btn"
                    >
                        <DButton
                            icon="lan-connect"
                            :label="__('settings.cloudpit_settings.check_api_connection')"
                            :disabled="onlyShowForm"
                            @click="checkCloudpitApiConnection"
                        />
                    </DCol>
                </DRow>
                <DFormRow
                    v-if="isSelectedType('cloudpit_classic_dns')"
                    :label="__('settings.cloudpit_settings.form.graphql_api_url')"
                    :is-required="true"
                    :error="errorsData.graphql_api_url"
                    :hint="__('settings.cloudpit_settings.form.graphql_api_url_hint')"
                >
                    <DInput
                        id="api_url"
                        v-model="form.graphql_api_url"
                        :placeholder="__('settings.cloudpit_settings.form.graphql_api_url')"
                        :is-valid="isFormFieldValid('graphql_api_url')"
                        :disabled="onlyShowForm"
                        maxlength="128"
                    />
                </DFormRow>
                <DFormRow
                    v-if="isSelectedType('cloudpit_classic_dns')"
                    :label="__('settings.cloudpit_settings.form.graphql_token')"
                    :is-required="true"
                    :error="errorsData.graphql_token"
                    :hint="__('settings.cloudpit_settings.form.graphql_token_hint')"
                >
                    <DFormTextarea
                        id="graphql_token"
                        :model-value="form.graphql_token"
                        :placeholder="__('settings.cloudpit_settings.form.graphql_token')"
                        :is-valid="isFormFieldValid('graphql_token')"
                        :disabled="onlyShowForm"
                        @update:modelValue="updateGraphqlToken"
                    />
                </DFormRow>
                <DRow
                    v-if="isSelectedType('cloudpit_classic_dns')"
                >
                    <DCol sm="4" />
                    <DCol sm="4">
                        <div
                            v-show="graphqlConnectionStatus === 'successful'"
                            class="green-text"
                        >
                            {{ __('settings.cloudpit_settings.connection_successful') }}
                        </div>
                        <div
                            v-show="graphqlConnectionStatus === 'unsuccessful'"
                            class="red-text"
                        >
                            {{ __('settings.cloudpit_settings.connection_unsuccessful') }}
                        </div>
                    </DCol>
                    <DCol
                        sm="4"
                        class="check-database-connection-btn"
                    >
                        <DButton
                            icon="lan-connect"
                            :label="__('settings.cloudpit_settings.check_graphql_connection')"
                            :disabled="onlyShowForm"
                            @click="checkGraphqlConnection"
                        />
                    </DCol>
                </DRow>
            </DCard>

            <!-- Domain Forward API Settings -->
            <DCard
                v-if="isSelectedType('onehop_dns')"
                :title="__('settings.dns_providers.form_segments.forwarding_service')"
                class="mb-4"
                padding
            >
                <DFormRow
                    :label="__('settings.dns_providers.form.configure_forwarding_service')"
                    is-required
                    :error="errors.configure_forwarding_service"
                    :hint="__('settings.dns_providers.form.configure_forwarding_service_hint')"
                >
                    <DSwitch
                        v-model="form.configure_forwarding_service"
                        color="success"
                        variant="3d"
                        :disabled="onlyShowForm"
                    />
                </DFormRow>
                <DFormRow
                    v-if="form.configure_forwarding_service"
                    :label="__('settings.dns_providers.form.forwarding_service_host')"
                    is-required
                    :error="errors.forwarding_service_host"
                    :hint="__('settings.dns_providers.form.forwarding_service_host_hint')"
                >
                    <DInput
                        id="forwarding_service_host"
                        v-model="form.forwarding_service_host"
                        :placeholder="__('settings.dns_providers.form.forwarding_service_host')"
                        :is-valid="isFormFieldValid('forwarding_service_host')"
                        :disabled="onlyShowForm"
                        maxlength="128"
                    />
                </DFormRow>
                <DFormRow
                    v-if="form.configure_forwarding_service"
                    :label="__('settings.dns_providers.form.forwarding_service_api_key')"
                    is-required
                    :error="errors.forwarding_service_api_key"
                    :hint="__('settings.dns_providers.form.forwarding_service_api_key_hint')"
                >
                    <DSecretInput
                        id="forwarding_service_api_key"
                        v-model="form.forwarding_service_api_key"
                        v-model:cleared="form.clear_forwarding_service_api_key"
                        :is-stored="storedSecrets.forwarding_service_api_key"
                        :placeholder="__('settings.dns_providers.form.forwarding_service_api_key')"
                        :is-valid="isFormFieldValid('forwarding_service_api_key')"
                        :disabled="onlyShowForm"
                        maxlength="255"
                    />
                </DFormRow>
                <DRow v-if="form.configure_forwarding_service">
                    <DCol sm="4" />
                    <DCol sm="4">
                        <div
                            v-show="domainForwardConnectionStatus === 'successful'"
                            class="green-text"
                        >
                            {{ __('settings.connections.connection_successful') }}
                        </div>
                        <div
                            v-show="domainForwardConnectionStatus === 'unsuccessful'"
                            class="red-text"
                        >
                            {{ __('settings.connections.connection_unsuccessful') }}
                        </div>
                    </DCol>
                    <DCol
                        sm="4"
                        class="check-database-connection-btn"
                    >
                        <DButton
                            icon="lan-connect"
                            :label="__('settings.connections.check_connection')"
                            :disabled="isInLoadingState"
                            @click="checkDomainForwardConnection"
                        />
                    </DCol>
                </DRow>
            </DCard>

            <!-- Dns Record Handling -->
            <DCard
                v-if="isSelectedType('onehop_dns')"
                :title="__('settings.dns_providers.form_segments.record_handling')"
                class="mb-4"
                padding
            >
                <DFormRow
                    :label="__('settings.dns_providers.form.keep_custom_records')"
                    is-required
                    :error="errors.keep_custom_records"
                    :hint="__('settings.dns_providers.form.keep_custom_records_hint')"
                >
                    <DSwitch
                        v-model="form.keep_custom_records"
                        color="success"
                        variant="3d"
                        :disabled="onlyShowForm"
                    />
                </DFormRow>
            </DCard>

            <!-- OneHop Nameservers -->
            <DCard
                :title="__('settings.dns_providers.form_segments.nameservers')"
                class="mb-4"
                padding
            >
                <DFormRow
                    :label="__('settings.dns_providers.form.ns_1')"
                    is-required
                    :error="errors.ns_one"
                    :hint="__('settings.dns_providers.form.ns_1_hint')"
                >
                    <DInput
                        id="ns_1"
                        v-model="form.ns_one"
                        :placeholder="__('settings.dns_providers.form.ns_1')"
                        :is-valid="isFormFieldValid('ns_1')"
                        :disabled="onlyShowForm"
                        maxlength="255"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('settings.dns_providers.form.ns_2')"
                    is-required
                    :error="errors.ns_two"
                    :hint="__('settings.dns_providers.form.ns_2_hint')"
                >
                    <DInput
                        id="ns_2"
                        v-model="form.ns_two"
                        :placeholder="__('settings.dns_providers.form.ns_2')"
                        :is-valid="isFormFieldValid('ns_2')"
                        :disabled="onlyShowForm"
                        maxlength="255"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('settings.dns_providers.form.ns_3')"
                    :error="errors.ns_three"
                    :hint="__('settings.dns_providers.form.ns_3_hint')"
                >
                    <DInput
                        id="ns_3"
                        v-model="form.ns_three"
                        :placeholder="__('settings.dns_providers.form.ns_3')"
                        :is-valid="isFormFieldValid('ns_3')"
                        :disabled="onlyShowForm"
                        maxlength="255"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('settings.dns_providers.form.ns_4')"
                    :error="errors.ns_four"
                    :hint="__('settings.dns_providers.form.ns_4_hint')"
                >
                    <DInput
                        id="ns_4"
                        v-model="form.ns_four"
                        :placeholder="__('settings.dns_providers.form.ns_4')"
                        :is-valid="isFormFieldValid('ns_4')"
                        :disabled="onlyShowForm"
                        maxlength="255"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('settings.dns_providers.form.ns_5')"
                    :error="errors.ns_five"
                    :hint="__('settings.dns_providers.form.ns_5_hint')"
                >
                    <DInput
                        id="ns_5"
                        v-model="form.ns_five"
                        :placeholder="__('settings.dns_providers.form.ns_5')"
                        :is-valid="isFormFieldValid('ns_5')"
                        :disabled="onlyShowForm"
                        maxlength="255"
                    />
                </DFormRow>

                <DFormRow
                    :label="__('settings.dns_providers.form.suspend_ns_1')"
                    :error="errors.suspend_ns_one"
                    :hint="__('settings.dns_providers.form.suspend_ns_1_hint')"
                >
                    <DInput
                        id="suspend_ns_1"
                        v-model="form.suspend_ns_one"
                        :placeholder="__('settings.dns_providers.form.suspend_ns_1')"
                        :is-valid="isFormFieldValid('suspend_ns_1')"
                        :disabled="onlyShowForm"
                        maxlength="255"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('settings.dns_providers.form.suspend_ns_2')"
                    :error="errors.suspend_ns_two"
                    :hint="__('settings.dns_providers.form.suspend_ns_2_hint')"
                >
                    <DInput
                        id="suspend_ns_2"
                        v-model="form.suspend_ns_two"
                        :placeholder="__('settings.dns_providers.form.suspend_ns_2')"
                        :is-valid="isFormFieldValid('suspend_ns_2')"
                        :disabled="onlyShowForm"
                        maxlength="255"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('settings.dns_providers.form.suspend_ns_3')"
                    :error="errors.suspend_ns_three"
                    :hint="__('settings.dns_providers.form.suspend_ns_3_hint')"
                >
                    <DInput
                        id="suspend_ns_3"
                        v-model="form.suspend_ns_three"
                        :placeholder="__('settings.dns_providers.form.suspend_ns_3')"
                        :is-valid="isFormFieldValid('suspend_ns_3')"
                        :disabled="onlyShowForm"
                        maxlength="255"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('settings.dns_providers.form.suspend_ns_4')"
                    :error="errors.suspend_ns_four"
                    :hint="__('settings.dns_providers.form.suspend_ns_4_hint')"
                >
                    <DInput
                        id="suspend_ns_4"
                        v-model="form.suspend_ns_four"
                        :placeholder="__('settings.dns_providers.form.suspend_ns_4')"
                        :is-valid="isFormFieldValid('suspend_ns_4')"
                        :disabled="onlyShowForm"
                        maxlength="255"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('settings.dns_providers.form.suspend_ns_5')"
                    :error="errors.suspend_ns_five"
                    :hint="__('settings.dns_providers.form.suspend_ns_5_hint')"
                >
                    <DInput
                        id="suspend_ns_5"
                        v-model="form.suspend_ns_five"
                        :placeholder="__('settings.dns_providers.form.suspend_ns_5')"
                        :is-valid="isFormFieldValid('suspend_ns_5')"
                        :disabled="onlyShowForm"
                        maxlength="255"
                    />
                </DFormRow>
            </DCard>
        </div>
        <DFormControls
            v-if="!onlyShowForm"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
        <DConnectionErrorModal
            :show-modal="connectionException !== null"
            :exception="connectionException"
            @close-modal="connectionException = null"
        />
    </DForm>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import DConnectionErrorModal from '~@/Components/Common/DConnectionErrorModal'
import { route } from '~@/Composables/route'
import { ref } from 'vue'

const props = defineProps({
    dnsProvider: {
        type: Object,
        default () {
            return {}
        }
    },
    onlyShowForm: {
        type: Boolean,
        default: () => false
    },
    apiTypes: {
        type: Array,
        default: () => { return [] }
    },
    errors: {
        type: Object,
        default: () => ({})
    },
    storedSecrets: {
        type: Object,
        default: () => ({})
    }
})

const connectionStatus = ref(null)
const domainForwardConnectionStatus = ref(null)
const errorsData = ref({})
const connectionException = ref(null)
const apiConnectionStatus = ref({})
const credentialsValid = ref({})
const graphqlConnectionStatus = ref({})
const selectedApiType = ref(props.dnsProvider.type)

const emit = defineEmits(['form-submitted'])

const form = useForm({
    id: props.dnsProvider.id ?? null,
    type: props.dnsProvider.type ?? null,
    name: props.dnsProvider.name ?? null,
    api_url: props.dnsProvider.api_url ?? null,
    api_username: props.dnsProvider.api_username ?? null,
    api_password: null,
    clear_api_password: false,
    api_brand: props.dnsProvider.api_brand ?? null,
    region: props.dnsProvider.region ?? null,
    ns_one: props.dnsProvider.ns_one ?? null,
    ns_two: props.dnsProvider.ns_two ?? null,
    ns_three: props.dnsProvider.ns_three ?? null,
    ns_four: props.dnsProvider.ns_four ?? null,
    ns_five: props.dnsProvider.ns_five ?? null,
    suspend_ns_one: props.dnsProvider.suspend_ns_one ?? null,
    suspend_ns_two: props.dnsProvider.suspend_ns_two ?? null,
    suspend_ns_three: props.dnsProvider.suspend_ns_three ?? null,
    suspend_ns_four: props.dnsProvider.suspend_ns_four ?? null,
    suspend_ns_five: props.dnsProvider.suspend_ns_five ?? null,
    configure_forwarding_service: props.dnsProvider.configure_forwarding_service ?? 0,
    forwarding_service_host: props.dnsProvider.forwarding_service_host ?? null,
    forwarding_service_api_key: null,
    clear_forwarding_service_api_key: false,
    login_url: props.dnsProvider.login_url ?? null,
    client_id: props.dnsProvider.client_id ?? null,
    client_secret: null,
    clear_client_secret: false,
    login_digits: props.dnsProvider.login_digits ?? null,
    login_prefix: props.dnsProvider.login_prefix ?? null,
    slug: props.dnsProvider.slug ?? null,
    dns_client_login: props.dnsProvider.dns_client_login ?? null,
    graphql_api_url: props.dnsProvider.graphql_api_url ?? null,
    graphql_token: props.dnsProvider.graphql_token ?? null,
    is_dns_provider: true,
    keep_custom_records: props.dnsProvider.keep_custom_records ?? false
})

const checkCloudpitApiConnection = function () {
    errorsData.value = {}
    connectionException.value = null

    window.axios.post(route('settings.cloudpit-settings.check-api-connection', form))
        .then(() => {
            apiConnectionStatus.value = 'successful'
            connectionException.value = null
            errorsData.value = {}
        })
        .catch((err) => {
            apiConnectionStatus.value = 'unsuccessful'
            credentialsValid.value = false

            if (err.response?.data?.error !== undefined) {
                errorsData.value = err.response.data
            }
            if (err.response?.data?.errors !== undefined) {
                errorsData.value = err.response.data.errors

                for (const key in errorsData.value) {
                    if (Array.isArray(errorsData.value[key])) {
                        errorsData.value[key] = errorsData.value[key][0]
                    }
                }
            }
            if (err.response?.data?.exception !== undefined) {
                connectionException.value = err.response.data.exception
            }
        })
}

const checkGraphqlConnection = function () {
    errorsData.value = {}
    connectionException.value = null
    window.axios.post(route('settings.cloudpit-settings.check-graphql-connection', form))
        .then(function () {
            graphqlConnectionStatus.value = 'successful'
        })
        .catch(function (error) {
            graphqlConnectionStatus.value = 'unsuccessful'
            if (error.response?.data?.errors !== undefined) {
                errorsData.value = error.response.data.errors

                for (const key in errorsData.value) {
                    if (Array.isArray(errorsData.value[key])) {
                        errorsData.value[key] = errorsData.value[key][0]
                    }
                }
            }
            if (error.response?.data?.exception !== undefined) {
                connectionException.value = error.response.data.exception
            }
        })
}

const updateGraphqlToken = function (token) {
    form.graphql_token = token
}

const checkConnection = function () {
    errorsData.value = {}
    window.axios.post(route('settings.dns-providers.check-connection', form))
        .then(function () {
            connectionStatus.value = 'successful'
        })
        .catch(function () {
            connectionStatus.value = 'unsuccessful'
        })
}

const checkDomainForwardConnection = function () {
    errorsData.value = {}
    window.axios.post(route('settings.dns-providers.forwarding-service-check-connection', form))
        .then(function () {
            domainForwardConnectionStatus.value = 'successful'
        })
        .catch(function () {
            domainForwardConnectionStatus.value = 'unsuccessful'
        })
}

const isSelectedType = function (apiType) {
    const defaultApiType = 'cloudpit_classic_dns'
    return selectedApiType.value === apiType || (selectedApiType.value == null && apiType === defaultApiType)
}

const updateSelectedApiType = function (value) {
    selectedApiType.value = value
}

const submitForm = () => {
    emit('form-submitted', form)
}

</script>

<style scoped lang="scss">

.check-database-connection-btn {
    text-align: right;
    padding-bottom: 25px;
}

.green-text {
    color: green;
}
.red-text {
    color: red;
}

</style>
